import { faSmileBeam, faSmile, faMeh, faSadCry, faAngry } from '@fortawesome/free-regular-svg-icons';
import { faFaceSmileBeam, faFaceSmile, faFaceMeh, faFaceSadCry, faFaceAngry } from '@fortawesome/free-solid-svg-icons';

export const feedbackIcons = [
    { id: 5, solid: faFaceAngry, regular: faAngry, color: '#FF2400', title: 'Very Negative' },
    { id: 4, solid: faFaceSadCry, regular: faSadCry, color: '#FF7700', title: 'Negative' },
    { id: 3, solid: faFaceMeh, regular: faMeh, color: '#FFBF00', title: 'Neutral' },
    { id: 2, solid: faFaceSmile, regular: faSmile, color: '#4FBB17', title: 'Good' },
    { id: 1, solid: faFaceSmileBeam, regular: faSmileBeam, color: '#008F39', title: 'Great' },
];
